module.exports = __webpack_public_path__ + "img/minion_breakdown_thumb.41b553d5.jpg";